import React from 'react';

const Menu: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    height="33"
    fill="none"
    viewBox="0 0 33 33"
    width="33"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path clipRule="evenodd" d={`M2 26C2 25.1716 2.55964 24.5 3.25 24.5H17.75C18.4404 24.5
      19 25.1716 19 26C19 26.8284 18.4404 27.5 17.75 27.5H3.25C2.55964 27.5 2 26.8284
      2 26Z`} fill="#231F20" fillRule="evenodd" />
    <path clipRule="evenodd" d={`M2 16C2 15.1716 2.52233 14.5 3.16667 14.5H28.8333C29.4777
      14.5 30 15.1716 30 16C30 16.8284 29.4777 17.5 28.8333 17.5H3.16667C2.52233 17.5 2
      16.8284 2 16Z`} fill="#231F20" fillRule="evenodd" />
    <path clipRule="evenodd" d={`M2 6C2 5.17157 2.55964 4.5 3.25 4.5H23.75C24.4404 4.5 25
      5.17157 25 6C25 6.82843 24.4404 7.5 23.75 7.5H3.25C2.55964 7.5 2 6.82843 2
      6Z`} fill="#231F20" fillRule="evenodd" />
  </svg>
);

export default Menu;
